import Menu from 'components/Menu';
import RoundyContainer from 'components/RoundyContainer';
import ChangeAddressConfirm_Main from 'components/StraightThroughAddressComp/3_Confirm/ChangeAddressConfirm_Main';
import { AddressChangeContext, AddressChangeContextComp } from 'components/StraightThroughAddressComp/AddressContext/AddressChangeContext';
import AddressProgressBreadCrumb from 'components/StraightThroughAddressComp/AddressProgressBar/AddressProgressBreadCrumb';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { storageData } from 'services/Services';

const ChangeAddress_Confirm = (props) => {
    const navigate = useNavigate()
    const { userData } = props.user
    const [showModal, setShowModal] = useState(true);
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    const handleClose = () => {
        setShowModal(false);
        userData["disclosureModal"] = true
        storageData.setItem("userData", JSON.stringify(userData));
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for COA Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementAddress")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <AddressChangeContextComp>
                <Menu Title={"ADDRESS CHANGE"} FirstName={userData.firstName} userData={userData} />
                <AddressProgressBreadCrumb requestContext={AddressChangeContext} screen={"Confirm"} />
                <RoundyContainer
                    Content={ChangeAddressConfirm_Main}
                    NoRoundy
                />
            </AddressChangeContextComp>
        </>
    )
}

export default ChangeAddress_Confirm